import type { AuditReason, AuditStatus, ReviewState } from "../types/api";

// The UI translates stable reason codes; it never parses the server's free text.
export const REASON_LABELS: Record<AuditReason, string> = {
  NO_MATCHING_SHIPMENT: "No shipment",
  DUPLICATE_PRO: "Duplicate",
  TOTAL_VARIANCE: "Total",
  WEIGHT_VARIANCE: "Weight",
  UNEXPECTED_ACCESSORIAL: "Accessorial",
};

export const REASON_DESCRIPTIONS: Record<AuditReason, string> = {
  NO_MATCHING_SHIPMENT: "No shipment or quote record for this PRO",
  DUPLICATE_PRO: "PRO billed on more than one invoice row",
  TOTAL_VARIANCE: "Billed total outside the money tolerance",
  WEIGHT_VARIANCE: "Billed weight outside the weight tolerance",
  UNEXPECTED_ACCESSORIAL: "Accessorial charge not approved on the shipment",
};

export const REASON_ORDER: AuditReason[] = [
  "NO_MATCHING_SHIPMENT",
  "DUPLICATE_PRO",
  "TOTAL_VARIANCE",
  "WEIGHT_VARIANCE",
  "UNEXPECTED_ACCESSORIAL",
];

export const STATUS_DESCRIPTIONS: Record<AuditStatus, string> = {
  PASS: "Matches the quote within tolerance",
  REVIEW: "Needs an operator's look before paying",
  HOLD: "Can't be audited: no matching shipment",
};

export const REVIEW_LABELS: Record<ReviewState, string> = {
  UNREVIEWED: "Unreviewed",
  APPROVED: "Approved",
  DISPUTE: "Dispute",
  IGNORED: "Ignored",
};

export function reasonSummary(codes: AuditReason[]): string {
  return codes.length ? codes.map((code) => REASON_LABELS[code]).join(" + ") : "—";
}
